import { BUTTON, classes } from "portal/theme/theme";
import { IconButton, IconButtonProps } from "@mui/material";
import React, { forwardRef } from "react";

interface SquareIconButtonProps extends IconButtonProps {
  theme: typeof BUTTON;
}

export const SquareIconButton = forwardRef<
  HTMLButtonElement,
  SquareIconButtonProps
>(function SquareIconButton({ theme, children, ...props }, ref) {
  return (
    <IconButton
      {...theme}
      {...props}
      className={classes(
        theme.className,
        "aspect-square rounded-sm h-8 sm:h-9",
        props.className
      )}
      ref={ref}
    >
      {children}
    </IconButton>
  );
});
